import Vue from 'vue';
import _ from 'lodash';
import {$http} from '@/utils/https';
import store from '@/store'
import { fixBody } from '@/helpers/variables/index';

import Moment from 'moment';
import {extendMoment} from 'moment-range';

const moment = extendMoment(Moment);

function getRangeDates(startDate, endDate, type = 'days') {
    let
        range = moment.range(startDate, endDate),
        array = Array.from(range.by(type));
    return array.length;
}

function totalAmount(obj) {
    let price = 0;
    if(store.state.profile.user){
        if(store.state.profile.user.inner){
            const remainder = obj.days % 60;
            const iterationValue = (obj.days - remainder) / 60;
            const amountWithIterations = (iterationValue * (obj.price / 2)) * obj.count;
            price = price + amountWithIterations;
            const amountRemainder = remainder * obj.price_rent;
            if(amountRemainder >= (obj.price / 2) ){
                price = price + ((obj.price / 2) * obj.count);
            }else{
                price = price + (amountRemainder * obj.count);
            }
        }else{
            price = Math.round((obj.days * obj.price_rent * obj.count) * 100) / 100;
        }
    }else{
        price = Math.round((obj.days * obj.price_rent * obj.count) * 100) / 100;
    }
    return price;
}

function save() {
    const parsed = JSON.stringify(state.whichList);
    localStorage.setItem('favoritesList', parsed);
}

import {
    SET_FAVORITES_LIST_LOADING,
    SET_FAVORITES_LIST,
    FAVORITES_INCREMENT_COUNT,
    FAVORITES_DECREMENT_COUNT,
    CHANGE_POPUP_EDIT_DATE,
    SET_EDIT_ITEM,
    CHANGE_OPEN_FAVORITES_LIST,
    FAVORITES_SET_EDITED_DATES,

    FAVORITES_UPDATE_NAME_LIST_LOADING,
    SET_FAVORITES_NAME_LIST,
    FAVORITES_SHOW_POPUP_EDIT_NAME_LIST,
    FAVORITES_REPORT_APPERANCE_LOADING,
    SET_EDITED_NAME_DATA,
    FAVORITES_REPORT_APPERANCE_SHOW_POPUP,
    FAVORITES_DATA_REPORT_APPERANCE,
    FAVORITES_CHANGE_POPUP_ADD_PERMISSIONS,
    FAVORITES_ADD_PERMISSIONS_LOADING,

    CHANGE_POPUP_ADD_TO_FAVORITES,

    CHANGE_POPUP_BOOKING,
    SET_SELECTED_PRODUCTS_BOOKING,

    FAVORITES_SET_NEW_WHICH_LIST,
    FAVORITES_SET_NEW_WHICH_LIST_LOADING,
    FRESH_FAVORITES_NAME_LIST,
    ADD_PRODUCT_TO_FAVORITE_LOADING,
    UPDATE_FAVORITES_LIST_AFTER_REMOVE_ITEM,
    FAVORITES_SAVE_LIST,
    FAVORITES_SORT_BY_TYPE,
    OPEN_CURRENT_LIST,
    SET_CURRENT_LIST_ID,

    SHOW_POPUP_REMOVE_FROM_FAVORITES,
    SET_DATA_REMOVE_FROM_FAVORITES,
    REMOVE_PRODUCT_IN_FAVORITE_LOADING,
    FAVORITES_MOVE_PRODUCT_LOADING,
    FAVORITES_SET_MOVING_PRODUCT,
    FAVORITES_DOWNLOAD_LIST,
    FAVORITES_GET_DOWNLOAD_LINK_LOADING,
    FAVORITES_SET_ITEM_COUNT,

    REMOVE_FAVORITE_LIST_LOADING,
    UPDATE_FAVORITES_AFTER_REMOVE_LIST,
    CHANGE_POPUP_FAVORITES_REMOVE_LIST,
    FAVORITES_FRESH_LIST
} from '../mutation-types';

import {
    GET_FAVORITES_LIST,
    FAVORITES_UPDATE_NAME_LIST,
    FAVORITES_REPORT_APPERANCE,
    FAVORITES_ADD_PERMISSIONS,
    FAVORITES_ADD_WHICH_LIST,
    FAVORITES_GET_WHICH_LIST,
    ADD_PRODUCT_TO_FAVORITE,
    REMOVE_PRODUCT_IN_FAVORITE,
    FAVORITES_MOVE_PRODUCT,
    FAVORITES_GET_DOWNLOAD_LINK,
    REMOVE_FAVORITE_LIST
} from '../action-types';


const state = {
    listId: null,
    moveProductLoading: false,

    list: null,
    editedItem: null,
    loading: false,

    loadingPrintList: false,

    showPopupEditNameList: false,
    updateNameLoading: false,
    editedNameData: null,

    showPopupEditDate: false,

    reportApperanceLoading: false,
    reportApperanceShowPopup: false,
    editedDataReportApperance: null,

    showPopupAddPermissions: {
        show: false,
        idList: ''
    },
    addPermissionsLoading: false,

    showPopupAddFavorites: false,

    addToFavoriteLoading: false,

    whichList: localStorage.getItem('favoritesList') ? JSON.parse(localStorage.getItem('favoritesList')) : [],
    whichListLoading: false,

    showPopupBooking: false,
    selectedProductsBooking: null,

    showPopupRemoveItem: false,
    removeDataItem: null,
    loadingRemoveProductToList: false,

    loadingRemoveList: false,
    popupRemoveList: {
        show: false,
        id: ''
    },
};

const getters = {
    loadingPrintList: state => state.loadingPrintList,
    loadingRemoveList: state => state.loadingRemoveList,
    popupRemoveList: state => state.popupRemoveList,

    moveProductLoading: state => state.moveProductLoading,
    showPopupRemoveItem: state => state.showPopupRemoveItem,
    loadingRemoveProductToList: state => state.loadingRemoveProductToList,
    removeDataItem: state => state.removeDataItem,

    listId: state => state.listId,

    showPopupBooking: state => state.showPopupBooking,
    selectedProductsBooking: state => state.selectedProductsBooking,

    list: state => state.list,
    loading: state => state.loading,
    updateNameLoading: state => state.updateNameLoading,
    editedNameData: state => state.editedNameData,
    showPopupEditNameList: state => state.showPopupEditNameList,
    showPopupEditDate: state => state.showPopupEditDate,
    editedItem: state => state.editedItem,

    addToFavoriteLoading: state => state.addToFavoriteLoading,

    reportApperanceLoading: state => state.reportApperanceLoading,
    reportApperanceShowPopup: state => state.reportApperanceShowPopup,
    editedDataReportApperance: state => state.editedDataReportApperance,

    showPopupAddPermissions: state => state.showPopupAddPermissions,
    addPermissionsLoading: state => state.addPermissionsLoading,

    showPopupAddFavorites: state => state.showPopupAddFavorites,

    whichList: state => state.whichList,
    whichListLoading: state => state.whichListLoading,
};

const actions = {
    [GET_FAVORITES_LIST]: async ({commit}, payload) => {
        commit(SET_FAVORITES_LIST_LOADING, true);
        try {
            const response = await $http.post('v1/favorites/info?include=products', payload);
            commit(SET_FAVORITES_LIST, response.data.data);
        } catch (e) {
            throw e;
        } finally {
            commit(SET_FAVORITES_LIST_LOADING, false);
        }
    },
    [FAVORITES_UPDATE_NAME_LIST]: async ({commit}, payload) => {
        commit(FAVORITES_UPDATE_NAME_LIST_LOADING, true);
        try {
            await $http.post(`v1/favorites/${payload.id}/update`, payload);
            commit(SET_FAVORITES_NAME_LIST, payload);
        } catch (e) {
            throw e;
        } finally {
            commit(FAVORITES_UPDATE_NAME_LIST_LOADING, false);
        }
    },
    [ADD_PRODUCT_TO_FAVORITE]: async ({commit}, payload) => {
        commit(ADD_PRODUCT_TO_FAVORITE_LOADING, true);
        try {
            return await $http.post(`v1/favorites/${payload.list.id}/product/add`, payload);
        } catch (e) {
            throw e;
        } finally {
            commit(ADD_PRODUCT_TO_FAVORITE_LOADING, false);
        }
    },
    [FAVORITES_REPORT_APPERANCE]: async ({commit}) => {
        commit(FAVORITES_REPORT_APPERANCE_LOADING, true);
        try {
            return await $http.get(`v1/faq`);
        } catch (e) {
            throw e;
        } finally {
            commit(FAVORITES_REPORT_APPERANCE_LOADING, false);
        }
    },
    [FAVORITES_GET_WHICH_LIST]: async ({commit}, payload) => {
        try {
            const response = await $http.post(`v1/favorites/info`, payload);
            commit(FRESH_FAVORITES_NAME_LIST, response.data.data)
        } catch (e) {
            throw e;
        }
    },
    [FAVORITES_ADD_PERMISSIONS]: async ({commit}, payload) => {
        commit(FAVORITES_ADD_PERMISSIONS_LOADING, true);
        try {
            return await $http.post(`v1/favorites/${payload.id}/share`, payload);
        } catch (e) {
            throw e;
        } finally {
            commit(FAVORITES_ADD_PERMISSIONS_LOADING, false);
        }
    },
    [FAVORITES_ADD_WHICH_LIST]: async ({commit}, payload) => {
        try {
            commit(FAVORITES_SET_NEW_WHICH_LIST_LOADING, true);

            const response =  await $http.post(`v1/favorites/create`, payload);
            commit(FAVORITES_SET_NEW_WHICH_LIST, response.data.data)
        } catch (e) {
            throw e;
        }finally {
            commit(FAVORITES_SET_NEW_WHICH_LIST_LOADING, false);
        }
    },
    [FAVORITES_MOVE_PRODUCT]: async ({commit}, payload) => {
        try {
            commit(FAVORITES_MOVE_PRODUCT_LOADING, true);

            await $http.post(`v1/favorites/product/move`, payload);
            commit(FAVORITES_SET_MOVING_PRODUCT, payload)
        } catch (e) {
            throw e;
        }finally {
            commit(FAVORITES_MOVE_PRODUCT_LOADING,false);
        }
    },
    [FAVORITES_GET_DOWNLOAD_LINK]: async ({commit}, payload) => {
        try {
            commit(FAVORITES_GET_DOWNLOAD_LINK_LOADING, {...payload, loading: true});

            const response =  await $http.get(`v1/favorites/${payload.id}/print`);
            commit(FAVORITES_DOWNLOAD_LIST, response.data)
        } catch (e) {
            throw e;
        }finally {
            commit(FAVORITES_GET_DOWNLOAD_LINK_LOADING, {...payload, loading: false});
        }
    },
    [REMOVE_PRODUCT_IN_FAVORITE]: async ({commit}) => {
        try {
            commit(REMOVE_PRODUCT_IN_FAVORITE_LOADING, true);

            const response = await $http.post(`v1/favorites/${state.removeDataItem.listId}/product/remove`, state.removeDataItem);
            commit(UPDATE_FAVORITES_LIST_AFTER_REMOVE_ITEM, state.removeDataItem);
            return response;
        } catch (e) {
            throw e;
        }finally {
            commit(REMOVE_PRODUCT_IN_FAVORITE_LOADING, false);
        }
    },
    [REMOVE_FAVORITE_LIST]: async ({commit}) => {
        try {
            commit(REMOVE_FAVORITE_LIST_LOADING, true);

            const response = await $http.post(`v1/favorites/${state.popupRemoveList.id}/delete`);
            commit(UPDATE_FAVORITES_AFTER_REMOVE_LIST, state.popupRemoveList.id);
            return response;
        } catch (e) {
            if(e.response.status === 422){
                commit(UPDATE_FAVORITES_AFTER_REMOVE_LIST, state.popupRemoveList.id);
                commit(CHANGE_POPUP_FAVORITES_REMOVE_LIST, { id: '', show: false })
            }
            throw e;
        }finally {
            commit(REMOVE_FAVORITE_LIST_LOADING, false);
        }
    },

};

const mutations = {
    [SET_FAVORITES_LIST](state, list) {
        state.list = list;
        state.list.map(e => {
            e.products.data.sort((a, b) => {
                const nameA = a.name.toLowerCase();
                const nameB = b.name.toLowerCase();
                if (nameA < nameB)
                    return -1;
                if (nameA > nameB)
                    return 1;
                return 0
            });
        });
        state.list.map(e => {
            e.loading = false;
            e.isHasList = state.whichList.some(e => e.id === e.id);
            e.isOpen = false;
            return e.products.data.map(t => {
                t.days = getRangeDates(t.to, t.from);
                t.priceRent = t.price_rent;
                t.available = true;
                t.img = t.img ? t.img : require('@/assets/img/default-img.jpg');
                t.warrantyAmount = Math.round((t.count * t.warranty_price) * 100) / 100;

                t.amount = totalAmount(t);
                return t;
            });
        });
    },
    [OPEN_CURRENT_LIST](state, id) {
        state.list.map((e, index) => {
            if(e.id === id){
                e.isOpen = true;
                Vue.set(state.list, index, e);
            }
        });
    },
    [UPDATE_FAVORITES_AFTER_REMOVE_LIST](state, id) {
        //remove item in localStorage
        const indexWhichList = _.findIndex(state.whichList, e => e.id === id);
        Vue.delete(state.whichList, indexWhichList)
        save();

        // delete list favorites
        const indexList = _.findIndex(state.list, e => e.id === id);
        Vue.delete(state.list, indexList)
    },
    [CHANGE_POPUP_FAVORITES_REMOVE_LIST](state, params) {
        state.popupRemoveList = params;
    },
    [FAVORITES_FRESH_LIST](state, data) {
        state.whichList.push(...data);
        let uniqList = _.uniqBy(state.whichList, 'id');
        state.whichList = uniqList;
    },
    [SET_CURRENT_LIST_ID](state, id) {
        state.listId = id;
    },
    [FAVORITES_GET_DOWNLOAD_LINK_LOADING](state, params) {
        state.list.forEach((e, index) => {
            if(e.id === params.id){
                e.loading = params.loading;
                Vue.set(state.list, index, e);
            }
        });
    },
    [FAVORITES_DOWNLOAD_LIST](state, data) {
        const link = document.createElement('a');
        link.href = `${process.env.VUE_APP_ROOT_API}v1/downloads/${data.link}`;
        link.setAttribute('type', 'hidden');
        link.setAttribute('download', 'download');
        document.body.appendChild(link);
        link.click();

    },
    [FAVORITES_MOVE_PRODUCT_LOADING](state, status) {
        state.moveProductLoading = status;
    },
    [FAVORITES_SET_MOVING_PRODUCT](state, params) {
        const indexListSrc = _.findIndex(state.list, e => e.id === params.src);
        const indexListDest = _.findIndex(state.list, e => e.id === params.dest);
        const indexListSrcItem = _.findIndex(state.list[indexListSrc].products.data, e => e.id === params.id);
        const movingItem = _.find(state.list[indexListSrc].products.data, e => e.id === params.id);

        //add item in dest list
        state.list[indexListDest].products.data.unshift(movingItem);

        //remove item in current list
        Vue.delete(state.list[indexListSrc].products.data, indexListSrcItem);



    },
    [SET_FAVORITES_LIST_LOADING](state, status) {
        state.loading = status;
    },
    [SET_SELECTED_PRODUCTS_BOOKING](state, status) {
        state.selectedProductsBooking = status;
    },
    [FAVORITES_SAVE_LIST](state, item) {
        state.list.map((e, index) => {
            if(e.id === item.id){
                e.isHasList = true;
                Vue.set(state.list, index, e);
            }
        });
        state.whichList.unshift({ id: item.id, name: item.name });
        save();
    },
    [UPDATE_FAVORITES_LIST_AFTER_REMOVE_ITEM](state, params) {
        const indexList = _.findIndex(state.list, e => e.id === params.listId);
        const indexItem = _.findIndex(state.list[indexList].products.data, e => e.id === params.id);
        Vue.delete(state.list[indexList].products.data, indexItem);
    },
    [SHOW_POPUP_REMOVE_FROM_FAVORITES](state, status) {
        state.showPopupRemoveItem = status;
        fixBody(status);
    },
    [SET_DATA_REMOVE_FROM_FAVORITES](state, data) {
        state.removeDataItem = data;
    },
    [REMOVE_PRODUCT_IN_FAVORITE_LOADING](state, data) {
        state.loadingRemoveProductToList = data;
    },
    [ADD_PRODUCT_TO_FAVORITE_LOADING](state, status) {
        state.addToFavoriteLoading = status;
    },
    [CHANGE_POPUP_EDIT_DATE](state, status) {
        state.showPopupEditDate = status;
        fixBody(state.showPopupEditDate)
    },
    [CHANGE_POPUP_BOOKING](state, status) {
        state.showPopupBooking = status;
        fixBody(status);
    },
    [SET_EDIT_ITEM](state, data) {
        state.editedItem = data;
    },
    [FAVORITES_SET_NEW_WHICH_LIST](state, item) {
        if(state.list){
            state.list.unshift({
                isHasList: state.whichList.some(e => e.id === e.id),
                isOpen: false,
                loading: false,
                ...item,
                products: {
                    data: []
                }
            });
        }
        state.whichList.unshift(item);
        save();
    },
    [SET_EDITED_NAME_DATA](state, data) {
        state.editedNameData = data;
    },
    [FAVORITES_UPDATE_NAME_LIST_LOADING](state, status) {
        state.updateNameLoading = status;
    },
    [REMOVE_FAVORITE_LIST_LOADING](state, status) {
        state.loadingRemoveList = status;
    },
    [FAVORITES_ADD_PERMISSIONS_LOADING](state, status) {
        state.addPermissionsLoading = status;
    },
    [FAVORITES_SET_NEW_WHICH_LIST_LOADING](state, status) {
        state.whichListLoading = status;
    },
    [FAVORITES_REPORT_APPERANCE_LOADING](state, status) {
        state.reportApperanceLoading = status;
    },
    [CHANGE_POPUP_ADD_TO_FAVORITES](state, status) {
        state.showPopupAddFavorites = status;
        fixBody(state.showPopupAddFavorites)
    },
    [FAVORITES_CHANGE_POPUP_ADD_PERMISSIONS](state, status) {
        state.showPopupAddPermissions = status;
        fixBody(state.showPopupAddPermissions.show)
    },
    [FAVORITES_REPORT_APPERANCE_SHOW_POPUP](state, status) {
        state.reportApperanceShowPopup = status;
        fixBody(state.reportApperanceShowPopup)
    },
    [FAVORITES_SHOW_POPUP_EDIT_NAME_LIST](state, status) {
        state.showPopupEditNameList = status;
        fixBody(state.showPopupEditNameList)
    },
    [FAVORITES_DATA_REPORT_APPERANCE](state, status) {
        state.editedDataReportApperance = status;
    },
    [FAVORITES_SORT_BY_TYPE](state, params) {
        const indexList = _.findIndex(state.list, e => e.id === params.id);
        const currentListProducts = state.list[indexList].products.data;

        function getRangeDates(startDate, endDate, type='days'){
            let
                range = moment.range(startDate, endDate),
                array = Array.from(range.by(type));

            return array.length;
        }

        switch (params.key) {
            case 'alphabeticalUp': {
                currentListProducts.sort((a, b) => {
                    const nameA = a.name.toLowerCase();
                    const nameB = b.name.toLowerCase();
                    if (nameA < nameB)
                        return -1;
                    if (nameA > nameB)
                        return 1;
                    return 0
                });
                break;
            }
            case 'alphabeticalDown': {
                currentListProducts.sort((a, b) => {
                    const nameA = a.name.toLowerCase();
                    const nameB = b.name.toLowerCase();
                    if (nameA > nameB)
                        return -1;
                    if (nameA < nameB)
                        return 1;
                    return 0
                });
                break;
            }
            case 'priceUp': {
                currentListProducts.sort((a, b) => {
                    return a.amount - b.amount;
                });
                break;
            }
            case 'priceDown': {
                currentListProducts.sort((a, b) => {
                    return b.amount - a.amount;
                });
                break;
            }
            case 'timeRentUp': {
                currentListProducts.sort((a, b) => {
                    return getRangeDates(a.from, a.to) - getRangeDates(b.from, b.to);
                });
                break;
            }
            case 'timeRentDown': {
                currentListProducts.sort((a, b) => {
                    return getRangeDates(b.from, b.to) - getRangeDates(a.from, a.to);
                });
                break;
            }
            default: {
                console.log('WTF');
            }
        }
    },
    [FRESH_FAVORITES_NAME_LIST](state, data) {
        state.whichList = data;
        save();
    },
    [SET_FAVORITES_NAME_LIST](state, params) {

        //update name in list favorites
        const indexList = _.findIndex(state.list, e => e.id === params.id);
        const elem = _.find(state.list, e => e.id === params.id);
        elem.name = params.name;
        Vue.set(state.list, indexList, elem);

        //update name in localStorage
        const indexWhichListEditItem = _.findIndex(state.whichList, e => e.id === params.id);
        if(indexWhichListEditItem >= 0){
            state.whichList[indexWhichListEditItem].name = params.name;
            save();
        }
    },
    [CHANGE_OPEN_FAVORITES_LIST](state, params) {
        const indexList = _.findIndex(state.list, e => e.id === params.id);
        const elem = _.find(state.list, e => e.id === params.id);
        elem.isOpen = params.status;

        Vue.set(state.list, indexList, elem);
    },
    [FAVORITES_SET_EDITED_DATES](state, data) {
        const indexList = _.findIndex(state.list, e => e.id === data.listId);
        const indexItem = _.findIndex(state.list[indexList].products.data, e => e.id === data.itemId);

        const elem = state.list[indexList].products.data[indexItem];

        elem.from = data.from;
        elem.to = data.to;
        elem.days = getRangeDates(data.to, data.from);
        elem.amount = totalAmount(elem);
    },
    [FAVORITES_INCREMENT_COUNT](state, data) {
        const indexList = _.findIndex(state.list, e => e.id === data.listId);
        const indexItem = _.findIndex(state.list[indexList].products.data, e => e.id === data.itemId);

        const elem = state.list[indexList].products.data[indexItem];

        if (elem.count < elem.total_count) {
            elem.count = elem.count + 1;
            elem.warrantyAmount = Math.round((elem.count * elem.warranty_price) * 100) / 100;
            elem.amount = totalAmount(elem);
        }
    },
    [FAVORITES_DECREMENT_COUNT](state, data) {
        const indexList = _.findIndex(state.list, e => e.id === data.listId);
        const indexItem = _.findIndex(state.list[indexList].products.data, e => e.id === data.itemId);

        const elem = state.list[indexList].products.data[indexItem];

        if (elem.count > 1) {
            elem.count = elem.count - 1;
            elem.warrantyAmount = Math.round((elem.count * elem.warranty_price) * 100) / 100;
            elem.amount = totalAmount(elem);
        }
    },
    [FAVORITES_SET_ITEM_COUNT](state, data) {
        const indexList = _.findIndex(state.list, e => e.id === data.listId);
        const indexItem = _.findIndex(state.list[indexList].products.data, e => e.id === data.id);

        const elem = state.list[indexList].products.data[indexItem];

        if (elem.count > 1 && elem.count <= elem.total_count) {
            elem.count = data.count;
            elem.warrantyAmount = Math.round((elem.count * elem.warranty_price) * 100) / 100;
            elem.amount = totalAmount(elem);
        }
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
